import { withAppCrashIfException } from 'epic';
import {
  fetchAddonSalesBeneficiariesEpic,
  fetchAddonSalesDesksEpic,
} from 'epic/postTradeOperations/addon/fetchAddonSalesActorsEpic';
import { createAddonManagementTabEpic } from 'epic/postTradeOperations/addonManagement/createAddonManagementTabEpic';
import { combineEpics } from 'redux-observable';
import type { EpicWithThunk } from 'state/state.common';

import { addonQuoteResultEpic } from './addonQuoteResultEpic';
import { createAddonTabEpic } from './createAddonTabEpic';
import { fetchAddonCustodiansEpic } from './fetchAddonCustodiansEpic';
import { fetchAddonFormEpic, resetAddonFormEpic } from './fetchAddonFormEpic';
import { fetchAddonFormWhenWorkspaceAlreadyInitializedEpic } from './fetchAddonFormWhenWorkspaceAlreadyInitializedEpic';
import { fetchMergedDealsEpic } from './fetchMergedDealsEpic';
import { onAddonFormChangedEpic } from './onAddonFormChangedEpic';
import { requestAddonQuoteEpic } from './requestAddonQuoteEpic';
import { handleTradeAckEpic, requestTradeEpic } from './requestTradeEpic';
import { fillAddonTabContentInPostTradeScreenEpic } from './tabContentEpic';
import { tradeTimerEpic } from './tradeTimerEpic';

export function addonFormEpic(): EpicWithThunk {
  return withAppCrashIfException(
    'addonForm',
    combineEpics(
      createAddonTabEpic(),
      createAddonManagementTabEpic(),
      fillAddonTabContentInPostTradeScreenEpic(),
      fetchAddonFormEpic(),
      resetAddonFormEpic(),
      fetchAddonFormWhenWorkspaceAlreadyInitializedEpic(),
      fetchAddonCustodiansEpic(),
      fetchMergedDealsEpic(),
      requestAddonQuoteEpic(),
      addonQuoteResultEpic(),
      onAddonFormChangedEpic(),
      requestTradeEpic(),
      handleTradeAckEpic(),
      tradeTimerEpic(),
      fetchAddonSalesDesksEpic(),
      fetchAddonSalesBeneficiariesEpic(),
    ),
  );
}
